/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { RegisterNotifyInterestBody } from '../models';
// @ts-ignore
import type { RegisterNotifyInterestResponse } from '../models';
/**
 * NotifyApiApi - axios parameter creator
 */
export const NotifyApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RegisterNotifyInterestBody} registerNotifyInterestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyApiRegisterNotifyInterest: async (registerNotifyInterestBody: RegisterNotifyInterestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerNotifyInterestBody' is not null or undefined
            assertParamExists('notifyApiRegisterNotifyInterest', 'registerNotifyInterestBody', registerNotifyInterestBody)
            const localVarPath = `/notify/interest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerNotifyInterestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotifyApiApi - functional programming interface
 */
export const NotifyApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotifyApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {RegisterNotifyInterestBody} registerNotifyInterestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyApiRegisterNotifyInterest(registerNotifyInterestBody: RegisterNotifyInterestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterNotifyInterestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyApiRegisterNotifyInterest(registerNotifyInterestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotifyApiApi.notifyApiRegisterNotifyInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotifyApiApi - factory interface
 */
export const NotifyApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotifyApiApiFp(configuration)
    return {
        /**
         * 
         * @param {NotifyApiApiNotifyApiRegisterNotifyInterestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyApiRegisterNotifyInterest(requestParameters: NotifyApiApiNotifyApiRegisterNotifyInterestRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterNotifyInterestResponse> {
            return localVarFp.notifyApiRegisterNotifyInterest(requestParameters.registerNotifyInterestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for notifyApiRegisterNotifyInterest operation in NotifyApiApi.
 */
export interface NotifyApiApiNotifyApiRegisterNotifyInterestRequest {
    readonly registerNotifyInterestBody: RegisterNotifyInterestBody
}

/**
 * NotifyApiApi - object-oriented interface
 */
export class NotifyApiApi extends BaseAPI {
    /**
     * 
     * @param {NotifyApiApiNotifyApiRegisterNotifyInterestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notifyApiRegisterNotifyInterest(requestParameters: NotifyApiApiNotifyApiRegisterNotifyInterestRequest, options?: RawAxiosRequestConfig) {
        return NotifyApiApiFp(this.configuration).notifyApiRegisterNotifyInterest(requestParameters.registerNotifyInterestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

